import React, { Component } from 'react'
import styled from 'styled-components'

export const ZoomInIcon = () => (
  <svg fill="#ffffff" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z" />
  </svg>
)

export const ZoomOutIcon = () => (
  <svg fill="#ffffff" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z" />
  </svg>
)

export const DownloadIcon = () => (
  <svg fill="#ffffff" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
)

export const CloseIcon = () => (
  <svg fill="#ffffff" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
)

export const SpinnerIcon = () => (
  <svg fill="#ffffff" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6zm10 14.5V20H8v-3.5l4-4 4 4zm-4-5l-4-4V4h8v3.5l-4 4z" />
    <path d="M0 0h24v24H0V0z" fill="none" />
  </svg>
)

const Header = ({ image, alt, zoomed, toggleZoom, onClose, enableDownload, enableZoom }) => (
  <div className="__react_modal_image__header">
    <span className="__react_modal_image__icon_menu">
      {enableDownload && (
        <a href={image} download>
          <DownloadIcon />
        </a>
      )}
      {enableZoom && <a onClick={toggleZoom}>{zoomed ? <ZoomOutIcon /> : <ZoomInIcon />}</a>}
      <a onClick={onClose}>
        <CloseIcon />
      </a>
    </span>
    {alt && <span className="__react_modal_image__caption">{alt}</span>}
  </div>
)

class Image extends Component {
  state = {
    loading: true
  }

  handleOnLoad = () => {
    this.setState({ loading: false })
  }

  handleOnContextMenu = event => {
    !this.props.contextMenu && event.preventDefault()
  }

  render() {
    const { id, className, src, style, handleDoubleClick } = this.props

    return (
      <React.Fragment>
        {this.state.loading && <SpinnerIcon />}
        <img
          id={id}
          className={className}
          src={src}
          style={style}
          onLoad={this.handleOnLoad}
          onDoubleClick={handleDoubleClick}
          onContextMenu={this.handleOnContextMenu}
          alt="alt_image"
        />
      </React.Fragment>
    )
  }
}

function appendStyle(id, css) {
  if (!document.head.querySelector('#' + id)) {
    const node = document.createElement('style')
    node.textContent = css
    node.type = 'text/css'
    node.id = id

    document.head.appendChild(node)
  }
}

class StyleInjector extends Component {
  componentDidMount() {
    appendStyle(this.props.name, this.props.css)
  }

  componentWillUnmount() {
    const node = document.getElementById(this.props.name)
    node.parentNode.removeChild(node)
  }

  render() {
    return null
  }
}

export const lightboxStyles = `
  body {
    overflow: hidden;
  }

  .__react_modal_image__modal_container {
    position: fixed;
    z-index: 9999999999;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    touch-action: none;
    overflow: hidden;

  }

  .__react_modal_image__modal_content {
    position: relative;
    height: 100%;
    width: 100%;
  }

  .__react_modal_image__modal_content img, 
  .__react_modal_image__modal_content svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    -webkit-transform: translate3d(-50%, -50%, 0);
    -ms-transform: translate3d(-50%, -50%, 0);
    overflow: hidden;
  }

  .__react_modal_image__medium_img {
    max-width: 98%;
    max-height: 98%;    
  }

  .__react_modal_image__large_img {
    cursor: move;
  }

  .__react_modal_image__icon_menu a {
    display: inline-block;
    font-size: 40px;
    cursor: pointer;
    line-height: 40px;
    box-sizing: border-box;
    border: none;
    padding: 0px 5px 0px 5px;
    margin-left: 10px;
    color: white;
    background-color: rgba(0, 0, 0, 0);
  }

  .__react_modal_image__icon_menu {
    display: inline-block;
    float: right;
  }

  .__react_modal_image__caption {
    display: inline-block;
    color: white;
    font-size: 120%;
    padding: 10px;
    margin: 0;
  }

  .__react_modal_image__header {
    position: absolute;
    top: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    overflow: hidden;
  }
`

class Lightbox extends Component {
  state = {
    move: { x: 0, y: 0 },
    moveStart: undefined,
    zoomed: false
  }

  handleKeyDown = event => {
    // ESC or ENTER closes the modal
    if (event.keyCode === 27 || event.keyCode === 13) {
      this.props.onClose()
    }
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown, false)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown, false)
  }

  getCoordinatesIfOverImg = event => {
    const point = event.changedTouches ? event.changedTouches[0] : event

    if (point.target.id !== 'react-modal-image-img') {
      // the img was not a target of the coordinates
      return
    }

    const dim = this.contentEl.getBoundingClientRect()
    const x = point.clientX - dim.left
    const y = point.clientY - dim.top

    return { x, y }
  }

  handleMouseDownOrTouchStart = event => {
    event.preventDefault()

    if (event.touches && event.touches.length > 1) {
      // more than one finger, ignored
      return
    }

    const coords = this.getCoordinatesIfOverImg(event)

    if (!coords) {
      // click outside the img => close modal
      this.props.onClose()
    }

    if (!this.state.zoomed) {
      // do not allow drag'n'drop if zoom has not been applied
      return
    }

    this.setState(prev => {
      return {
        moveStart: {
          x: coords.x - prev.move.x,
          y: coords.y - prev.move.y
        }
      }
    })
  }

  handleMouseMoveOrTouchMove = event => {
    event.preventDefault()

    if (!this.state.zoomed || !this.state.moveStart) {
      // do not allow drag'n'drop if zoom has not been applied
      // or if there has not been a click
      return
    }

    if (event.touches && event.touches.length > 1) {
      // more than one finger, ignored
      return
    }

    const coords = this.getCoordinatesIfOverImg(event)

    if (!coords) {
      return
    }

    this.setState(prev => {
      return {
        move: {
          x: coords.x - prev.moveStart.x,
          y: coords.y - prev.moveStart.y
        }
      }
    })
  }

  handleMouseUpOrTouchEnd = event => {
    this.setState({
      moveStart: undefined
    })
  }

  toggleZoom = event => {
    event.preventDefault()
    this.setState(prev => ({
      zoomed: !prev.zoomed,
      // reset position if zoomed out
      move: prev.zoomed ? { x: 0, y: 0 } : prev.move
    }))
  }

  render() {
    const { medium, large, alt, onClose, hideDownload, hideZoom } = this.props
    const { move, zoomed } = this.state

    return (
      <React.Fragment>
        <StyleInjector name="__react_modal_image__lightbox" css={lightboxStyles} />

        <div className="__react_modal_image__modal_container">
          <div className="__react_modal_image__modal_content">
            {zoomed && (
              <Image
               /*  onMouseDown={this.handleMouseDownOrTouchStart}
                onMouseUp={this.handleMouseUpOrTouchEnd}
                onMouseMove={this.handleMouseMoveOrTouchMove}
                onTouchStart={this.handleMouseDownOrTouchStart}
                onTouchEnd={this.handleMouseUpOrTouchEnd}
                onTouchMove={this.handleMouseMoveOrTouchMove} */
                ref={el => {
                  this.contentEl = el
                }}
                id="react-modal-image-img"
                className="__react_modal_image__large_img"
                src={large || medium}
                style={{
                  transform: `translate3d(-50%, -50%, 0) translate3d(${move.x}px, ${move.y}px, 0)`,
                  WebkitTransform: `translate3d(-50%, -50%, 0) translate3d(${move.x}px, ${move.y}px, 0)`,
                  MsTransform: `translate3d(-50%, -50%, 0) translate3d(${move.x}px, ${move.y}px, 0)`
                }}
                handleDoubleClick={this.toggleZoom}
              />
            )}
            {!zoomed && (
              <Image
                id="react-modal-image-img"
                className="__react_modal_image__medium_img"
                src={medium || large}
                handleDoubleClick={this.toggleZoom}
                contextMenu={!medium}
              />
            )}
          </div>

          <Header
            image={large || medium}
            alt={alt}
            zoomed={zoomed}
            toggleZoom={this.toggleZoom}
            onClose={onClose}
            enableDownload={!hideDownload}
            enableZoom={!hideZoom}
          />
        </div>
      </React.Fragment>
    )
  }
}

const ModalWrapper = styled.div`
  margin: 0 auto;
  & > img {
    height: ${props => (props.height ? props.height : ' 42px')};
  }
  .__react_modal_image__modal_container {
    /* z-index: 9999999 !important; */
    /* touch-action: pinch-zoom; */
    & img {
      width: 100%;
    }
  }
  .__react_modal_image__header {
    height: 60px;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;
  }
`
export default class ModalLightbox extends Component {
  state = { modalOpen: false }

  toggleModal = () => {
    this.setState(prev => ({
      modalOpen: !prev.modalOpen
    }))
  }

  render() {
    const { className, small, smallSrcSet, medium, large, alt, hideDownload, hideZoom, height, ...props } = this.props
    const { modalOpen } = this.state

    return (
      <React.Fragment>
        <ModalWrapper height={height} {...props}>
          <img
            className={className}
            style={{
              cursor: 'pointer',
              maxWidth: '100%',
              maxHeight: '100%'
            }}
            onClick={this.toggleModal}
            src={small}
            srcSet={smallSrcSet}
            alt={alt}
          />
          {modalOpen && (
            <Lightbox
              medium={medium}
              large={large}
              alt={alt}
              onClose={this.toggleModal}
              hideDownload={hideDownload}
              hideZoom={hideZoom}
            />
          )}
        </ModalWrapper>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ModalLightbox.js